export const CONFIG = {
  // Environment
  NODE_ENV: process.env.NODE_ENV || 'development',

  // API Configuration
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  LEGACY_APP_URL: process.env.REACT_APP_LEGACY_APP_URL,
  
  // Authentication
  SESSION_COOKIE_NAME: process.env.REACT_APP_SESSION_COOKIE_NAME,
  PARENT_DOMAIN: process.env.REACT_APP_PARENT_DOMAIN,
  AUTH_BASE_URL: process.env.REACT_APP_AUTH_BASE_URL,
  POST_LOGIN_REDIRECT_URI: process.env.REACT_APP_POST_LOGIN_REDIRECT_URI,

  // Localization
  APP_STORE_LANGUAGE: process.env.REACT_APP_STORE_LANGUAGE,
  
  // MFE URLs
  SMARTSEARCH_MFE_URL: process.env.REACT_APP_SMARTSEARCH_MFE_URL,
  CONTACTUS_MFE_URL: process.env.REACT_APP_CONTACTUS_MFE_URL,
  CHECKOUT_MFE_URL: process.env.REACT_APP_CHECKOUT_MFE_URL,
  ENTERPRISESEARCH_MFE_URL: process.env.REACT_APP_ENTERPRISESEARCH_MFE_URL,
  MYAPPS_MFE_URL: process.env.REACT_APP_MYAPPS_MFE_URL,
  APP_DETAILS_MFE_URL: process.env.REACT_APP_APP_DETAILS_MFE_URL,
  EMPLOYEE_WELLNESS_MFE_URL: process.env.REACT_APP_EMPLOYEE_WELLNESS_MFE_URL,
  APIC_MFE_URL: process.env.REACT_APP_APIC_MFE_URL,

  // AppShell URLs
  SHELL_URL: process.env.REACT_APP_SHELL_URL,

  
  // Feature Flags
  ENABLE_ANALYTICS: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
  ENABLE_HEADLESS_MYAPPS: process.env.REACT_APP_ENABLE_HEADLESS_MYAPPS === 'true',
  ENABLE_HEADLESS_CHECKOUT: process.env.REACT_APP_ENABLE_HEADLESS_CHECKOUT === 'true',
  ENABLE_HEADLESS_APPDETAILS: process.env.REACT_APP_ENABLE_HEADLESS_APPDETAILS === 'true',
  ENABLE_HEADLESS_APIC: process.env.REACT_APP_ENABLE_HEADLESS_APIC === 'true',
  DEBUG_MODE: process.env.REACT_APP_DEBUG_MODE === 'true',
  
  // Additional settings
  LOG_LEVEL: process.env.REACT_APP_LOG_LEVEL,
  CDN_URL: process.env.REACT_APP_CDN_URL,
  ENABLE_SERVICE_WORKER: process.env.REACT_APP_ENABLE_SERVICE_WORKER === 'true',
  ENV_VALUE: process.env.REACT_APP_ENV_NAME,

  // Pendo
  REACT_APP_PENDO: process.env.REACT_APP_PENDO,

  // Stage
  REACT_APP_STAGE: process.env.REACT_APP_STAGE || 'IAT',
  // Interaction Studio (Evergage)
  REACT_APP_INTERACTION_STUDIO_LIB: process.env.REACT_APP_INTERACTION_STUDIO_LIB,

  // GA4
  REACT_APP_GA4_ID: process.env.REACT_APP_GA4_ID,

  // GTM
  REACT_APP_GTM_ID: process.env.REACT_APP_GTM_ID,

  // Computed properties
  get IS_PRODUCTION() {
    return this.NODE_ENV === 'production';
  },
  
  get IS_DEVELOPMENT() {
    return this.NODE_ENV === 'development';
  }
};
// Log configuration in development
if (CONFIG.DEBUG_MODE) {
  console.log('🔧 AppShell App Configuration:', {
    environment: CONFIG.NODE_ENV,
    apiBaseUrl: CONFIG.API_BASE_URL,
    legacyAppUrl: CONFIG.LEGACY_APP_URL,
    smartSearchUrl: CONFIG.SMARTSEARCH_MFE_URL,
    enterpriseSearchUrl: CONFIG.ENTERPRISESEARCH_MFE_URL,
    appStoreLanguage: CONFIG.APP_STORE_LANGUAGE,
    contactUsUrl: CONFIG.CONTACTUS_MFE_URL,
    checkoutUrl: CONFIG.CHECKOUT_MFE_URL,
    myAppsUrl: CONFIG.MYAPPS_MFE_URL,
    employeeWellnessUrl: CONFIG.EMPLOYEE_WELLNESS_MFE_URL,
    envValue: CONFIG.ENV_VALUE,
    shellUrl: CONFIG.SHELL_URL,
    enableAnalytics: CONFIG.ENABLE_ANALYTICS,
    enableHeadlessMyApps: CONFIG.ENABLE_HEADLESS_MYAPPS,
    enableHeadlessCheckout: CONFIG.ENABLE_HEADLESS_CHECKOUT,
    enableHeadlessAppDetails: CONFIG.ENABLE_HEADLESS_APPDETAILS,
    debugMode: CONFIG.DEBUG_MODE
  });
}
